<template>
  <d2-container>
    <template slot="header">
      <el-select
        @keyup.enter.native="getSearch"
        v-model="listQuery.status"
        clearable
        placeholder="请选择状态"
        size="small"
        style="margin-top:5px;margin-right: 20px;"
      >
        <el-option v-for="item in StatusList" :key="item.key" :label="item.value" :value="item.key"></el-option>
      </el-select>
      <el-button @click="getSearch" class="filter-item" type="primary" icon="search" size="small">搜索</el-button>
    </template>
    <el-button
      class="filter-item"
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      v-permission:function="['growMentManger:btn_add']"
      @click="getAdd"
    >新增</el-button>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      style=" margin-top: 20px"
      :data="themeAgreement"
    >
      <el-table-column align="center" label="id">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="活动名称">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="标题">
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="副标题">
        <template slot-scope="scope">
          <span>{{ scope.row.subTitle }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="加速所需成长币数量">
        <template slot-scope="scope">
          <span>{{ scope.row.creditCount }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="加速倍数">
        <template slot-scope="scope">
          <span>{{ scope.row.speedUpMultiple }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="开始时间">
        <template slot-scope="scope">
          <span>{{ scope.row.startTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="结束时间">
        <template slot-scope="scope">
          <span>{{ scope.row.endTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="120" label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0">未开始</span>
          <span v-if="scope.row.status == 1">进行中</span>
          <span v-if="scope.row.status == 2">已结束</span>
          <span v-if="scope.row.status == 3">已关闭</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" width="220">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            @click="editGrow(scope.row.id)"
            style="margin-top: 10px;margin-right:10px"
            v-permission:function="['growMentManger:btn_edit']"
          >编辑</el-button>
          <span v-permission:function="['growMentManger:btn_off']">
            <el-button
              size="small"
              type="success"
              @click="offMent(scope.row.id)"
              v-if="scope.row.status != 3"
              style="margin-top: 10px;"
            >关闭</el-button>
          </span>
          <span v-permission:function="['growMentManger:btn_put']">
            <el-button
              size="small"
              type="success"
              @click="putOnMent(scope.row.id)"
              v-if="scope.row.status == 3"
              style="margin-top: 10px;"
            >开启</el-button>
          </span>
        </template>
      </el-table-column>
    </el-table>
    <template slot="footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuery.currentPage"
        :page-sizes="[10,20,30, 50]"
        :page-size="listQuery.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="width:500px"
      ></el-pagination>
    </template>
  </d2-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { getList, getOpen, getClose } from '@/api/demo/growMent/index'
export default {
  name: 'growMentManger',
  data () {
    return {
      growMentManger_btn_add: false,
      growMentManger_btn_edit: false,
      growMentManger_btn_off: false,
      growMentManger_btn_put: false,

      total: null,
      listLoading: true, // 加载圈圈
      themeAgreement: [], // 列表
      tableKey: 0,
      listQuery: {
        currentPage: 1,
        pageSize: 20,
        status: null
      },
      StatusList: [
        { key: 0, value: '未开始' },
        { key: 1, value: '进行中' },
        { key: 2, value: '已结束' },
        { key: 3, value: '已关闭' }
      ],
      computed: {
        ...mapGetters(['elements'])
      }
    }
  },
  created () {
    this.getAgreementList()
  },
  watch: {
    $route (to, from) {
      this.getAgreementList()
    }
  },
  mounted () {
    // this.getAgreementList();
  },
  methods: {
    getAdd () {
      this.$router.push({
        path: '/demo/growMent/growAdd'
      })
    },
    getAgreementList (val) {
      let that = this
      if (val) {
        that.listQuery.currentPage = val
      } else {
        that.listQuery.currentPage = 1
      }
      if (that.listQuery.status === '') {
        that.listQuery.status = null
      }
      getList(that.listQuery).then(res => {
        that.listLoading = true
        that.themeAgreement = res.records
        that.total = parseInt(res.total)
        that.listLoading = false
      })
    },
    editGrow (id) {
      this.$router.push({
        path: '/demo/growMent/growAdd',
        query: {
          id: id
        }
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getAgreementList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getAgreementList(val)
    },
    // 关闭
    offMent (id) {
      let that = this
      getClose(id).then(res => {
        that.$notify({
          title: '成功',
          message: '关闭成功',
          type: 'success',
          duration: 2000
        })
        that.getAgreementList(that.listQuery.currentPage)
      })
    },
    // 开启
    putOnMent (id) {
      let that = this
      getOpen(id).then(res => {
        that.$notify({
          title: '成功',
          message: '开启成功',
          type: 'success',
          duration: 2000
        })
        that.getAgreementList(that.listQuery.currentPage)
      })
    },
    getSearch () {
      let that = this
      that.getAgreementList()
    }
  }
}
</script>
<style scoped>
</style>
